import { Button } from '@shared/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: Error | null;
  onRetry?: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  const { t } = useTranslation('shippingRulePresetsModule');

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
      {/* Icono de error */}
      <AlertTriangle className="h-16 w-16 text-error" />
      <div className="text-center space-y-2">
        <h3 className="text-lg font-semibold text-title">{t('empty.title')}</h3>
        <p className="text-sm text-subtext">{error?.message}</p>
      </div>
      {onRetry && (
        <Button onClick={onRetry} variant="outline" data-testid="error-retry-button">
          Reintentar
        </Button>
      )}
    </div>
  );
};
